import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from './themeShared';

const style = createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    label: {
      fontSize: 'md',
      fontWeight: '400',
      _disabled: {
        opacity: 0.6,
      },
    },
    control: {
      boxSize: 5,
      borderColor: getThemes(theme).colors.palette.neutral[60],
      borderRadius: 4,
      bg: 'transparent',
      _checked: {
        bg: getThemes(theme).colors.palette.primary[50],
        borderColor: getThemes(theme).colors.palette.primary[50],
        _disabled: {
          bg: getThemes(theme).colors.palette.primary[0],
          borderColor: getThemes(theme).colors.palette.primary[0],
          color: getThemes(theme).colors.palette.primary[100],
        },
      },
      _indeterminate: {
        bg: getThemes(theme).colors.palette.primary[50],
        borderColor: getThemes(theme).colors.palette.primary[50],
        _hover: {
          bg: getThemes(theme).colors.palette.primary[50],
          borderColor: getThemes(theme).colors.palette.primary[50],
          color: getThemes(theme).colors.palette.primary[100],
        },
      },
      _hover: {
        borderColor: getThemes(theme).colors.palette.primary[50],
        bg: 'transparent',
        _disabled: {
          bg: 'transparent',
          borderColor: getThemes(theme).colors.palette.neutral[60],
        },
        _checked: {
          bg: getThemes(theme).colors.palette.primary[50],
          borderColor: getThemes(theme).colors.palette.primary[50],
        },
      },
      _disabled: {
        borderColor: getThemes(theme).colors.palette.neutral[60],
        opacity: 0.6,
        bg: 'transparent',
      },
      _focusVisible: {
        boxShadow: 'none',
      },
      _invalid: {
        borderColor: getThemes(theme).colors.palette.errors[50],
        _hover: {
          borderColor: getThemes(theme).colors.palette.errors[50],
          _checked: {
            bg: getThemes(theme).colors.palette.errors[50],
            borderColor: getThemes(theme).colors.palette.errors[50],
          },
        },
        _checked: {
          bg: getThemes(theme).colors.palette.errors[50],
        },
      },
    },
  });

const accordion = () => style.definePartsStyle({});

const photo = (theme: ThemesKeys) =>
  style.definePartsStyle({
    control: {
      bg: getThemes(theme).colors.palette.primary[0],
      borderColor: getThemes(theme).colors.palette.primary[100],
      _checked: {
        bg: getThemes(theme).colors.palette.primary[0],
        borderColor: getThemes(theme).colors.palette.primary[100],
      },
      _hover: {
        bg: getThemes(theme).colors.palette.primary[0],
        borderColor: getThemes(theme).colors.palette.primary[100],
        _checked: {
          borderColor: getThemes(theme).colors.palette.primary[100],
        },
      },
    },
  });

const filter = () =>
  style.definePartsStyle({
    label: {
      maxW: '85%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  });

export const checkBoxTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
    variants: {
      filter: filter(),
      accordion: accordion(),
      photo: photo(theme),
    },
    sizes: {
      smSelect: {
        control: {
          boxSize: 5,
        },
        icon: {
          boxSize: 2.5,
        },
      },
      mdSelect: {
        control: {
          boxSize: 5,
        },
        icon: {
          boxSize: 2.5,
        },
      },
      lgSelect: {
        control: {
          boxSize: 6,
        },
        icon: {
          boxSize: 3,
        },
      },

      sm: {
        control: {
          boxSize: 4,
        },
      },
      md: {
        control: {
          boxSize: 5,
        },
      },
      lg: {
        control: {
          boxSize: 6,
        },
      },
      xl: {
        control: {
          boxSize: 7,
        },
        label: {
          fontSize: 'xl',
        },
      },
    },
  });

export default (theme: ThemesKeys) => checkBoxTheme(theme);
